<script setup>
import { PopoverArrow, PopoverContent } from 'reka-ui'

defineProps({
    side: {
        type: String,
        default: 'top',
    },
    sideOffset: {
        type: Number,
        default: 5,
    },
    arrowFillColor: {
        type: String,
        default: 'fill-white',
    },
})

const inDialog = inject('inDialog', false)
</script>

<template>
    <!-- When rendered inline inside a Dialog (portal disabled), focus leaving the
         content fires focusOutside and would close the popover. Suppress it so
         only real outside clicks (interactOutside) close it. -->
    <PopoverContent
        :side="side"
        :side-offset="sideOffset"
        :collision-padding="{ top: 16, right: 16, bottom: 16, left: 16 }"
        prioritize-position
        class="relative z-12000 rounded-xl border border-slate-100 bg-white shadow-md will-change-[transform,opacity]"
        v-bind="inDialog ? { onFocusOutside: (e) => e.preventDefault() } : {}"
    >
        <slot />

        <slot name="arrow">
            <PopoverArrow :class="[arrowFillColor]" class="stroke-slate-200" />
        </slot>
    </PopoverContent>
</template>
